// extracted by mini-css-extract-plugin
module.exports = {"label":"index_label__F26O7","radio":"index_radio__Lal0E","container":"index_container__Op83b","group":"index_group__x_7mQ","item":"index_item__3fr_Z"};